import { Navigate, Outlet, useLocation } from "react-router";

import { useAuth } from "./useAuth";

/**
 * Portão das rotas autenticadas.
 *
 * Enquanto o backend não respondeu `/auth/me` não decidimos nada — renderizar
 * a tela de login por um instante e depois trocar seria pior que esperar.
 *
 * Ao redirecionar, guardamos a rota pretendida para voltar a ela após o login.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <output aria-live="polite" data-testid="auth-loading">
        Verificando sua sessão…
      </output>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
